export class Constants {
  public static readonly INVOICE_TYPE_ID = '64ae0ffe-5d65-4a87-8e0a-63c4c6ebcb7c';
  public static readonly SALE_TICKET_ID = '8ef17b0f-9515-41ce-b7e8-e9d758a511b4';
  public static readonly CREDIT_NOTE_ID = '80fc7809-e291-4c32-ab97-36bf1bcd6ccf';
  public static readonly DEBIT_NOTE_ID = '5c5d233d-e983-4ecc-bdc9-70974ad32ea3';
  public static readonly TAX_EXEMPTION_REASON_TAXED = 'B561EBDB-EF88-4B55-8CAC-AB06E04B6117';
  public static readonly TAX_EXEMPTION_REASON_UNAFFECTED_FREE_TRANSFER =
    '97a1044354bf4464bec387644eea44b9';
  public static readonly TAX_EXEMPTION_REASON_INAFECT = '2239FA6F-75CC-491C-827F-6DB1929B3E80';
  public static readonly ID_DOCUMENT_TYPE_DNI = '03ed706c-a9fa-4d4f-bc70-fb30284628a5';
  public static readonly ID_DOCUMENT_TYPE_RUC = 'f5eb2fdb-3238-44cb-87bc-1b1e9781f7cf';
  public static readonly ID_DOCUMENT_TYPE_DT = 'b5ded797-c2a4-41aa-8099-0dfc0d54a1e7';
  public static readonly THRESHOLD_SALE_TICKET = 700;
  public static readonly FREIGHT_CODE = '7812163';
  public static readonly UNIT_OF_MEASURE_UN = 'NIU';
  public static readonly ID_NUMBER_DT = '88888888';
  public static readonly CREDIT_NOTE_CODE = '07';
  public static readonly FREIGHT_PRODUCT_CODE = '2';
  public static readonly FREIGHT_KEY = 'FREIGHT';
  public static readonly DESPATCH_TYPE_ID = '90e5d0a6-6ced-426d-99ac-0980bff6d6cc';
  public static readonly DESPATCH_CODE = '09';
  public static readonly PRIVATE_TRANSPORT_MODALITY_ID = '9eb15b39-047f-4e88-b7a2-2ba4ab9b84b5';
}
